import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'
import moment from 'moment'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.ADD = (state, payload) => {
  state.row = payload
}
mutations.SUBMISSIONS = (state, payload) => {
  state.submission_rows = payload
}

const state = {
  rows: [],
  row: null
}

const actions = {
  init: ({ commit }) => {
    const ctx = {
      data: {
        init: { api: 'M0601SurveyService.init' }
      }
    }
    return client.postData(ctx)
      .then((data) => {
        const output = data.init.output
        if (output.length === 0) {
          SysUtils.showInfo('No record found')
        }
        commit('FIND_ALL', output)
      })
  },
  doAdd: ({ commit }) => {
    console.debug('called M0601Survey add')
    commit('EDIT', {
      status: 1,
      questions: [
        { choices: [{}], type: 0, must_ans: 1, files: {} }
      ]
    })
  },
  doSave: ({ commit }, row) => {
    console.debug('called M0601Survey saveSurveyForm')
    if (row.start_date) {
      row.start_date = moment(row.start_date).utc().format('YYYY-MM-DD HH:mm:ss')
    }
    if (row.end_date) {
      row.end_date = moment(row.end_date).utc().format('YYYY-MM-DD HH:mm:ss')
    }
    return client.postData({ data: { save: { api: 'M0601SurveyService.saveSurveyForm', input: row } } })
      .then((data) => {
        const output = data.save.output
        if (output.error) {
          return false
        } else {
          commit('EDIT', {
            status: 1,
            questions: [
              { choices: [{}], type: 0, must_ans: 1, files: {} }
            ]
          })
          commit('FIND_ALL', output)
          if (output.msg) {
            SysUtils.showInfo(output.msg)
          }
          return true
        }
      })
  },
  doEdit: ({ commit }, id) => {
    console.debug('called M0601Survey getSurveyFormData')
    return client.postData({ data: { edit: { api: 'M0601SurveyService.getSurveyFormData', input: id } } })
      .then((data) => {
        const output = data.edit.output
        if (output.start_date) {
          output.start_date = moment.utc(output.start_date).local().format('YYYY-MM-DD HH:mm:ss')
        }
        if (output.end_date) {
          output.end_date = moment.utc(output.end_date).local().format('YYYY-MM-DD HH:mm:ss')
        }
        commit('EDIT', output)
      })
  },
  doDelete: ({ commit }, id) => {
    return client.postData({ data: { delete: { api: 'M0601SurveyService.deleteSurveyForm', input: id } } })
      .then((data) => {
        const output = data.delete.output
        commit('EDIT', {
          status: 1,
          questions: [
            { choices: [{}], type: 0, must_ans: 1, files: {} }
          ]
        })
        commit('FIND_ALL', output)
        if (output.length === 0) {
          SysUtils.showInfo('No record found')
        }
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
